// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"b697e52b","483":"efe315ec","565":"67e77bf2","845":"f47ec353","998":"18adb628"}[chunkId] + ".chunk.js";
};